<template>
  <div id="index-app" class="row">
    <div class="homepage-content">
      <div class="titles d-flex flex-column text-center py-3">
        <a class="text-decoration-none" href="analysis.html">
          <h1 class="text-body font-weight-bold">TESAS</h1>
          <h5 class="text-body font-weight-bold">Taiwan Economic Society Analysis System</h5>
          <h4 class="text-body font-weight-bold">地方創生資料庫</h4>
          <h6 class="small text-black-50 font-weight-bold px-3">為創造更友善的使用環境及體驗，地方創生資料庫（TESAS）歡迎各界反饋使用經驗，以作為修正改進之參考。</h6>
        </a>
        <h6 class="small text-black-50 font-weight-bold px-3">
          本網站為促進資料之共用，亦同時以 API 介接方式提供資料介接，並以 Swagger UI 提供介接案例以協助介接參數等內容之理解。詳見 <a href="../tesas_api/swagger/index.html">TESAS Swagger</a> 網頁及<a href="docs/TESAS-API_簡易使用說明.pdf">說明文件</a>。
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import "../../css/custom_var";
@import "../../css/custom_mixin";

#index-hero {
  width: 100%;
  height: 600px;
  position: relative;

  .swiper-container {
    height: 100%;
  }

  .swiper-pagination {
    bottom: 120px;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: white;
  }
}
.homepage-content {
  position: relative;
  width: 100%;
  height: calc(100vh - 154px);
  background: url("../../assets/images/1-index_page/img-hp-banner-4.png");
  background-size: auto 150%;
  background-position: center;
  background-repeat: no-repeat;
  .titles {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 254, 248, 0.85);
    h1 {
      font-size: 100px;
    }
  }
}
</style>
